import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ArchivePagesMutationVariables } from '../src/__types__/ArchivePagesMutation.ts';
import type { ArchiveDialogProps } from '../src/ArchiveProcessContainer.tsx';

export const ArchivePagesLoader: LoadableType<{
	contentId: string;
	source: ArchiveDialogProps<ArchivePagesMutationVariables>['source'];
	onSuccess?: () => void;
	onLinkClick?: () => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivePagesLoader" */ '../src/ArchivePagesLoader.tsx'
			)
		).ArchivePagesLoader,
});
